import { createAction } from 'redux-actions';
import { actionKey } from '../constants';

export const initialize = createAction(
  `${actionKey}.INITIALIZE`,
  (deviationId: number) => ({ deviationId })
);

export const initializeSuccess = createAction(
  `${actionKey}.INITIALIZE_SUCCESS`,
  (payload: {
    deviationId: number;
    tags: string[];
    recommendedTags: string[];
  }) => payload
);

export const initializeError = createAction(
  `${actionKey}.INITIALIZE_ERROR`,
  (errorMessage: string) => ({ errorMessage })
);

export const deinitialize = createAction(
  `${actionKey}.DEINITIALIZE`,
  () => ({})
);

export const boost = createAction(
  `${actionKey}.BOOST`,
  (deviationId: number, duration: number, tags: string[]) => ({
    deviationId,
    duration,
    tags,
  })
);

export const boostSuccess = createAction(
  `${actionKey}.BOOST_SUCCESS`,
  (payload: { deviationId: string }) => payload
);

export const boostError = createAction(
  `${actionKey}.BOOST_ERROR`,
  (errorMessage: string) => ({ errorMessage })
);
